/* eslint-disable no-plusplus */
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';

export const prepareLessonRelatedList = (
  lesson: ILessonSection[],
  lessonId: ILessonSection['id'],
  fillCount = 3,
): ILessonSection[] => {
  const filteredLesson = lesson.filter(item => String(item.id) !== String(lessonId));
  if (!filteredLesson.length) return [];

  const index = lesson.findIndex(item => String(item.id) === String(lessonId));

  const output: ILessonSection[] = [];
  const availableBefore = index;
  const availableAfter = filteredLesson.length - index - 1;

  const beforeCount = Math.min(fillCount, availableBefore);
  const afterCount = Math.min(fillCount, availableAfter);

  for (let i = index - beforeCount; i < index; i++) {
    if (filteredLesson[i]) output.push(filteredLesson[i]);
  }

  for (let i = index; i <= index + afterCount; i++) {
    if (filteredLesson[i]) output.push(filteredLesson[i]);
  }

  const missingBefore = fillCount - beforeCount;
  const missingAfter = fillCount - afterCount;

  for (let i = index - beforeCount - missingBefore; i < index; i++) {
    if (filteredLesson[i]) output.unshift(filteredLesson[i]);
  }

  for (let i = index + 1; i <= index + afterCount + missingAfter; i++) {
    if (filteredLesson[i]) output.push(filteredLesson[i]);
  }

  return output;
};
